import type { MetaFunction } from 'react-router'
import ReviewsPage from '~/pages/ReviewsPage.jsx'

export const meta: MetaFunction = () => [
  { title: 'Reviews | S.J.S. Technology' },
  {
    name: 'description',
    content:
      'Customer reviews and testimonials for S.J.S. Technology VICTORY printing machines — real feedback from signage, textile, and packaging businesses.',
  },
  { property: 'og:title', content: 'Reviews | S.J.S. Technology' },
  { property: 'og:url', content: 'https://sjstechnology.in/reviews' },
]

export default function Reviews() {
  return <ReviewsPage />
}
